import { isAxiosError } from 'axios';
import type { AxiosError } from 'axios';
import type { ApiError } from '@libs/api/types';

interface ErrorResponse {
  success: boolean;
  error: ApiError | null;
  message: string | null;
  data: unknown;
}

const isErrorResponse = (data: unknown): data is ErrorResponse =>
  typeof data === 'object' && data !== null && 'success' in data && 'error' in data;

export const getErrorMessage = (error: AxiosError): string | null => {
  if (!isAxiosError(error)) return null;

  const data = error.response?.data;

  if (!isErrorResponse(data)) return null;

  // 최상위 message 필드를 우선 사용
  if (data.message) {
    return data.message;
  }

  // fallback: error.message 사용
  if (data.error?.message) {
    return data.error.message;
  }

  return '작업 도중 에러가 발생하였습니다.\n' + '문제가 지속되는 경우 관리자에게 문의하여 주십시오.';
};

export const logInfo = (error: AxiosError): void => {
  if (!isAxiosError(error)) {
    return;
  }

  const data = error.response?.data;

  if (!isErrorResponse(data)) {
    return;
  }

  if (data.error) {
    const { code, message } = data.error;
    console.info(`${code} - ${message}`);
  }
};

export const logWarn = (error: AxiosError): void => {
  if (!isAxiosError(error)) {
    return;
  }

  const data = error.response?.data;

  if (!isErrorResponse(data)) {
    return;
  }

  if (data.error) {
    const { code, message } = data.error;
    console.warn(`${code} - ${message}`);
  }
};

export const logError = (error: AxiosError): void => {
  if (!isAxiosError(error)) {
    return;
  }

  const data = error.response?.data;

  if (!isErrorResponse(data)) {
    return;
  }

  if (data.error) {
    const { code, message } = data.error;
    console.error(`${code} - ${message}`);
  }
};
